<script context="module" lang="ts">
	import Section from '$lib/components/layout/Section.svelte';
	import type { SectionConfig } from '$lib/util/pagebuilder';
	import { onDestroy } from 'svelte';
	import { gql } from 'graphql-request';

	export const config: SectionConfig = {
		collection: 'section_testimonials',
		availableFor: ['pages', 'special-pages'],
		query: gql`
            translations {
                languages_code {
                    code
                }
                title
                
            }
            media {
            ...Media
            }
            link {
            ...Link
            }
			testimonials {
				testimonial_id {
					media {
						...Media
					}
					translations {
						languages_code {
							code
						}
						text
						name
					}
				}
			}
    `
	};
	type Props = {
		title: string;
		media: any;
		link: any;
		testimonials: any[];
	};
</script>

<script lang="ts">
	import Wysiwyg from '$lib/components/inputs/WYSIWYG.svelte';
	import Media from '$lib/components/media/Media.svelte';
	import GlobalMedia from '$lib/components/media/GlobalMedia.svelte';
	import DirectusLink from '$lib/components/navigation/DirectusLink.svelte';
	import Button from '$lib/components/util/Button.svelte';
	import Slider from '$lib/components/util/Slider.svelte';

	export let data: Props; // the components gets all data via this prop (additionally each top level prop is directly provided to the component)

	// let activeIdx = 0;

	// let interval = setInterval(() => {
	// 	activeIdx += 1;
	// 	activeIdx %= data.testimonials?.length ?? 1;
	// }, 8000);

	// onDestroy(() => {
	// 	clearInterval(interval);
	// });
</script>

<Section class="section-testimonials" gapType="padding">
	<div class="wrapper">
		<div class="col1">
			<div class="container">
				<div class="logos">
					<div class="stars">
						<GlobalMedia key="icon-stars" fit="contain" />
					</div>
					<!-- <div class="truspilot">
						<GlobalMedia key="trustpilot" fit="contain" />
					</div> -->
				</div>
				<div class="title">
					{data.title}
				</div>

				<div class="testimonial-slider">
					<Slider
						name="slider"
						type="single"
						pagination={false}
						navigation={true}
						centeredSlides={false}
					>
						{#each data.testimonials as testimonial, idx}
							<div class="testimonial swiper-slide">
								<div class="text-wrapper">
									<div class="text">{testimonial?.testimonial_id?.text ?? ''}</div>
									<div class="name">{testimonial?.testimonial_id?.name ?? ''}</div>
								</div>
							</div>
						{/each}
					</Slider>
				</div>

				<DirectusLink {...data.link}>
					<Button {...data.link} style="yellow" />
				</DirectusLink>
			</div>
		</div>
		<div class="image-wrapper">
			<Media {...data.media} fit="cover" transform="l" />
		</div>
	</div></Section
>

<style lang="scss">
	:global(.section-testimonials .inner-section) {
		max-width: 1200px !important;
	}
	.title {
		@include font(h4);
	}
	.wrapper {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		background: color(white);
		border-radius: v(border-radius);
		position: relative;
	}
	.container {
		display: flex;
		flex-direction: column;
		justify-content: center;
		height: 100%;
		width: 100%;
	}
	.logos {
		display: flex;
		gap: v(content-gap);
		margin-bottom: v(content-gap-sm);
		.stars {
			max-width: 100px;
		}
		.truspilot {
			max-width: 100px;
		}
	}
	.image-wrapper {
		width: 100%;
		height: 100%;
		overflow: hidden;
		// :global(img) {
		// 	aspect-ratio: 16 / 9;
		// }
	}
	.col1 {
		padding: v(content-padding-2xl) v(content-padding-2xl);
		@media (max-width: 1400px) {
			padding: v(content-padding-lg) v(content-padding-2xl);
		}
	}
	.text-wrapper {
		padding: v(content-padding-sm) v(content-padding-lg);
	}

	.testimonial-slider {
		border-top: solid 1px color(black);
		border-bottom: solid 1px color(black);
		position: relative;
		margin: v(content-gap-sm) 0;
		:global(.navigation) {
			position: absolute;
			top: 50%;
			inset-inline-start: 0;
			width: 100%;
			transform: translateY(-50%);
			z-index: 2;
			display: flex;
			justify-content: space-between;
			padding-bottom: 0 !important;
		}
	}
	.name {
		margin-top: v(content-gap);
		@include font(info-sm);
		font-weight: bold;
	}

	@media (max-width: 800px) {
		.text-wrapper {
			padding: v(content-padding) v(content-padding-5xl);
		}

		.wrapper {
			display: flex;
			flex-direction: column;
		}
		.col1 {
			padding: v(content-padding-lg);
		}
		.logos {
			.stars,
			.truspilot {
				max-width: 80px;
			}
		}
	}
	@include media(phone) {
		.text-wrapper {
			padding: v(content-gap) v(content-padding-xl);
		}
	}
</style>
